import { render } from "./ImageStep.vue?vue&type=template&id=383b9e74&scoped=true"
import script from "./ImageStep.vue?vue&type=script&lang=js"
export * from "./ImageStep.vue?vue&type=script&lang=js"

import "./ImageStep.vue?vue&type=style&index=0&id=383b9e74&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-383b9e74"

export default script